import { render, staticRenderFns } from "./UserCreateForm.vue?vue&type=template&id=cca93d32&scoped=true&"
import script from "./UserCreateForm.vue?vue&type=script&lang=js&"
export * from "./UserCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./UserCreateForm.vue?vue&type=style&index=0&id=cca93d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca93d32",
  null
  
)

export default component.exports